<template>
  <div>
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    >
      <span class="font-weight-bold font-size-3 text-dark-60">
        Nếu bạn đã có tài khoản?
      </span>
      <router-link
        class="font-weight-bold font-size-3 ml-2"
        :to="{ name: 'login' }"
      >
        Đăng Nhập
      </router-link>
    </div>
    <!--end::Content header-->

    <!--begin::Signup-->
    <div v-if="!isRegistered" class="login-form login-signin">
      <div class="text-center mb-10 mb-lg-20">
        <h3 class="font-size-h1">Đăng Ký</h3>
        <p class="text-muted font-weight-semi-bold">
          Vui lòng nhập thông tin tài khoản
        </p>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            id="example-input-1"
            v-model="$v.form.email.$model"
            class="form-control form-control-solid h-auto py-5 px-6"
            name="example-input-1"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
            placeholder="Địa chỉ email"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Vui lòng nhập địa chỉ email hợp lệ
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
        >
          <b-form-input
            id="example-input-2"
            v-model="$v.form.password.$model"
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            name="example-input-2"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
            placeholder="Mật khẩu"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Vui lòng nhập mật khẩu
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-3"
          label=""
          label-for="example-input-3"
        >
          <b-form-input
            id="example-input-3"
            v-model="$v.form.passwordConfirm.$model"
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            name="example-input-3"
            :state="validateState('passwordConfirm')"
            aria-describedby="input-3-live-feedback"
            placeholder="Xác nhận mật khẩu"
          ></b-form-input>

          <b-form-invalid-feedback id="input-3-live-feedback">
            Mật khẩu không đúng
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-group-4"
          label-for="example-input-4"
          label-size="sm"
        >
          <b-form-select
            id="example-input-4"
            v-model="form.type"
            required
            :options="accountTypes"
            size="sm"
          ></b-form-select>
        </b-form-group>

        <!--begin::Action-->
        <div class="form-group d-flex flex-wrap flex-center">
          <button
            ref="scr_login_signup_submit"
            type="submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
          >
            Tạo tài khoản
          </button>
          <button
            class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
            @click="$router.push('login')"
          >
            Quay lại trang đăng nhập
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signup-->

    <b-card
      v-if="isRegistered"
      border-variant="light"
      img-src="media/bg/checked_bg.png"
      img-alt="Success"
      img-top
      title="Đăng ký thành công"
      align="center"
    >
      <b-card-text
        >Trước khi bắt đầu sử dụng, SCR sẽ liên lạc và xác nhận một số thông tin
        của bạn. Chúng tôi sẽ liên hệ sớm với bạn qua email.</b-card-text
      >
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from 'vuex';
import { REGISTER } from '@/core/services/store/auth.module';
import { LOGOUT } from '@/core/services/store/auth.module';

import { validationMixin } from 'vuelidate';
import { email, required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'Register',
  mixins: [validationMixin],
  data() {
    return {
      isRegistered: false,
      form: {
        email: null,
        password: null,
        passwordConfirm: null,
        type: 'basic'
      },
      accountTypes: [
        { value: 'basic', text: 'Cơ Bản' },
        { value: 'pro', text: 'Đặc Biệt' }
      ]
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      passwordConfirm: {
        required,
        minLength: minLength(8)
      },
      type: {
        required
      }
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors
    })
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];

      if ($dirty) {
        if (name === 'passwordConfirm' && !$error) {
          return this.$v.form[name].$model === this.$v.form.password.$model;
        }
        return !$error;
      }

      return null;
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;
      const type = this.$v.form.type.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs['scr_login_signup_submit'];
      submitButton.classList.add('spinner', 'spinner-light', 'spinner-right');

      await this.$store.dispatch(REGISTER, {
        email: email,
        password: password,
        type: type
      });

      submitButton.classList.remove(
        'spinner',
        'spinner-light',
        'spinner-right'
      );

      this.isRegistered = true;

      // this.$router.push({ name: 'dashboard' });
    }
  }
};
</script>
